import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAfricanEmptyState = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 489,
	height: 429,
	viewBox: "0 0 489 429",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M197.827 278.804C197.827 278.804 101.565 224.826 119.789 92.2108C119.789 92.2108 212.504 147 197.827 278.804Z",
			fill: "#DEE9FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M125.177 227.643C125.177 227.643 42.381 237.014 57.6526 133.886C57.6526 133.886 128.819 145.887 125.177 227.643Z",
			fill: "#DEE9FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M190.743 283.091C190.743 283.091 97.3424 330.879 43.5294 235.27C43.5294 235.27 130.438 211.454 190.743 283.091Z",
			fill: "#DEE9FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.225 110.37C243.14 118.065 245.882 125.429 250.223 131.848C239.84 137.491 223.541 132.583 230.021 122.143C230.021 122.143 216.72 123.365 215.295 110.665L242.225 110.37Z",
			fill: "#FFC2E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M253.49 50.3954C233.825 42.7383 240.455 68.7706 240.455 68.7706C229.147 64.5301 219.797 71.6147 219.159 78.2197L246.069 87.9309C245.638 85.7322 248.593 84.0297 248.593 84.0297C249.768 80.3115 253.32 75.2018 261.127 75.2722C269.144 75.3444 272.03 84.3333 272.03 84.3333C272.03 84.3333 273.723 85.9773 273.446 83.8789C273.331 83.0078 271.87 78.083 272.811 77.7426C274.566 77.1078 280.605 80.9871 284.026 83.4557C289.434 87.3581 290.667 99.1115 291.984 104.819C293.47 111.261 301.339 123.336 305.12 128.855C305.12 128.855 331.772 122.997 319.238 104.712C319.246 104.675 351.952 75.6117 322.487 67.1933C303.876 61.8757 302.937 49.9952 292.945 41.196C273.152 23.766 274.629 58.626 253.49 50.3954Z",
			fill: "#FFC2E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M286.767 90.1211C290.06 98.5643 288.657 104.356 283.266 92.2339C275.134 73.9458 271.262 76.8442 273.054 80.9442",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M278.684 79.8892C278.684 79.8892 287.063 83.3909 292.441 93.6458",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M281.811 81.6401C281.811 81.6401 287.688 81.515 290.44 85.1418",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M277.735 102.485C277.735 102.485 280.623 109.316 268.494 104.59C255.215 99.4166 252.542 103.198 253.713 104.43",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M328.602 179.37C323.708 173.018 305.117 125.06 300.49 122.543",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M278.345 111.015C278.416 114.25 284.092 125.444 286.949 127.034C294.753 131.378 304.759 192.467 311.036 205.02C313.895 210.739 323.005 213.74 327.727 211.211C337.49 205.98 335.509 183.142 332.021 177.214",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M261.501 123.573C261.501 123.573 261.146 120.091 271.889 117.73",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.225 110.37C242.225 110.37 245.542 137.496 262.295 139.133C275.236 140.398 283.613 127.874 283.613 127.874",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M218.059 130.106C222.662 126.419 216.957 107.072 221.162 103.135",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M224.799 106.481C224.799 106.481 223.344 107.15 222.085 110.692C220.653 114.718 223.964 108.634 227.811 110.065C231.658 111.497 231.747 116.149 231.747 116.149",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M230.226 111.05C230.226 111.05 238.129 104.116 244.551 103.392C250.418 102.732 242.572 107.918 239.889 113.018",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M212.24 102.733C212.24 102.733 211.271 122.537 203.409 129.226C199.991 132.134 196.831 144.736 188.907 159.711C178.575 179.235 174.092 200.069 173.828 209.827C173.691 214.898 178.609 220.761 184.641 221.431C189.388 221.959 201.845 217.932 212.334 212.026",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M198.322 197.407C198.322 197.407 203.812 166.268 206.214 159.148",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200.653 184.659C200.653 184.659 210.076 172.392 216.784 168.99C222.231 166.227 234.989 166.012 240.43 165.149C247.992 163.948 253.754 156.506 254.124 141.814",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M263.607 167.407C263.607 167.407 264.635 175.747 266.806 174.948C268.977 174.148 270.119 168.207 280.402 166.493",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M297.722 197.327C297.722 206.77 254.584 228.096 286.209 200.591C308.853 180.897 304.651 178.13 299.539 180.951",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M325.201 217.961C325.201 217.961 318.469 235.469 322.078 240.062",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M215.313 281.496C215.313 281.496 220.251 282.415 213.912 255.364C205.812 220.8 216.836 210.522 216.836 210.522C216.836 210.522 220.866 206.869 252.801 196.4C286.441 185.373 290.888 175.272 297.988 166.585",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M222.118 201.202C220.727 203.674 219.597 206.284 218.746 208.989",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M221.69 101.825C227.472 101.825 232.159 97.1381 232.159 91.3565C232.159 85.575 227.472 80.8881 221.69 80.8881C215.909 80.8881 211.222 85.575 211.222 91.3565C211.222 97.1381 215.909 101.825 221.69 101.825Z",
			fill: "#C2D1FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M261.71 98.9134C267.473 98.9134 272.145 94.2416 272.145 88.4786C272.145 82.7156 267.473 78.0438 261.71 78.0438C255.947 78.0438 251.276 82.7156 251.276 88.4786C251.276 94.2416 255.947 98.9134 261.71 98.9134Z",
			fill: "#C2D1FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M260.244 98.9476C266.832 98.9476 272.172 93.6073 272.172 87.0198C272.172 80.4322 266.832 75.0919 260.244 75.0919C253.657 75.0919 248.317 80.4322 248.317 87.0198C248.317 93.6073 253.657 98.9476 260.244 98.9476Z",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M254.898 82.5216C254.001 83.6163 253.329 84.877 252.919 86.2317C252.509 87.5863 252.37 89.0084 252.51 90.4168C252.65 91.8251 253.066 93.1922 253.734 94.4398C254.402 95.6874 255.31 96.7913 256.404 97.6883C257.499 98.5852 258.76 99.2578 260.114 99.6676C261.469 100.077 262.891 100.216 264.299 100.076C265.708 99.9366 267.075 99.5208 268.323 98.8526C269.57 98.1845 270.674 97.2772 271.571 96.1824",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M271.302 83.2107C269.997 81.9052 268.317 81.0389 266.496 80.7322C264.675 80.4255 262.804 80.6937 261.143 81.4994C259.482 82.3052 258.113 83.6085 257.227 85.2282C256.341 86.8479 255.981 88.7034 256.198 90.5369",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M271.717 84.084L264.036 91.7651",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M264.548 87.4958L260.018 92.0253",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M213.571 79.6658C211.123 81.0246 209.255 83.2292 208.316 85.8666C207.377 88.504 207.432 91.3932 208.471 93.993C209.509 96.5928 211.46 98.7248 213.957 99.9896C216.455 101.254 219.328 101.565 222.038 100.864C224.748 100.162 227.11 98.4968 228.68 96.1793C230.251 93.8617 230.922 91.0511 230.569 88.2739C230.216 85.4968 228.862 82.9436 226.762 81.0928C224.661 79.242 221.958 78.2205 219.159 78.2197",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M211.959 88.8185C211.331 90.9101 212.795 94.2566 214.072 94.9546",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M229.442 84.773C228.051 83.3825 226.262 82.4599 224.323 82.1332C222.384 81.8066 220.391 82.0922 218.621 82.9504C216.852 83.8087 215.394 85.1968 214.45 86.9219C213.506 88.647 213.123 90.6234 213.354 92.5762",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.417 90.3505L215.847 97.92",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M222.717 94.3934L218.484 98.6266",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M235.326 88.1663C238.51 92.5973 236.549 98.0217 234.791 100.314",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M231.551 82.9004C231.551 82.9004 234.884 86.3988 236.346 86.0562C237.808 85.7136 235.545 83.5468 235.586 83.0404C235.628 82.534 239.965 84.6403 241.09 87.1431",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M226.425 104.87C233.805 104.87 246.967 101.816 246.967 92.5045C246.967 90.0485 245.409 86.7301 242.507 85.666",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.426 107.735L215.965 100.754",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M244.155 107.668C245.927 108.618 247.823 109.317 249.787 109.747C252 110.015 255.097 109.381 255.815 107.228",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M252.21 96.1261C252.21 96.1261 254.463 101.247 248.591 104.524",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M265.335 110.756C265.566 110.943 265.754 111.176 265.888 111.441C266.021 111.705 266.097 111.995 266.11 112.292C266.124 112.588 266.074 112.883 265.964 113.159C265.854 113.434 265.687 113.684 265.474 113.89C263.996 115.368 261.435 114.656 260.67 114.238C259.904 113.82 259.416 113.542 259.834 114.725",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M255.193 114.031C255.378 114.389 255.693 114.662 256.074 114.795",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M253.358 111.244C252.592 113.054 253.567 115.561 254.751 115.004",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M316.54 155.044C316.54 155.044 323.804 156.896 325.804 159.145C327.803 161.394 335.56 177.839 334.345 181.484",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M316.107 210.441C310.336 228.979 247.435 249.439 231.076 256.749C219.288 262.017 264.816 254 293.557 237.755",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M207.109 162.371C207.594 159.461 188.718 155.431 187.263 157.694C187.263 157.694 181.65 168.463 183.75 168.383C187.644 168.236 203.286 171.881 204.604 173.88",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M193.052 145.256C193.052 145.256 190.673 142.948 202.67 145.256C214.321 147.498 214.982 149.873 214.982 149.873",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M191.122 154.811C191.122 154.811 185.124 149.652 200.859 149.493C211.043 149.39 216.741 152.215 212.998 152.669",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M292.174 141.106C292.174 141.106 290.956 139.279 301.513 134.203C312.069 129.128 309.836 134 309.836 134",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M296.018 148.535C286.914 150.423 303.568 135.101 311.006 134.99",
			stroke: "#3B57F6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M392.044 359.252C395.179 356.725 398.242 354.042 401.201 351.149C418.156 334.571 429.011 317.579 435.625 301.121L378.642 295.822L438.369 293.625C457.05 236.896 427.476 188.424 427.476 188.424C427.476 188.424 427.163 198.131 400.023 213.078L387.536 248.149L382.043 221.88C361.38 230.986 331.329 241.399 287.596 252.4L287.535 252.417L296.79 276.654L280.019 254.411C246.434 263.712 223.352 276.037 207.59 289.214L231.521 313.934L192.09 305.145C166.121 338.68 177.487 372.123 177.487 372.123C177.487 372.123 233.971 393.896 295.556 391.589L289.019 350.735L305.494 391.002C328.011 389.178 350.83 383.835 371.503 372.808L347.559 336.23L392.044 359.252Z",
			fill: "#DEE9FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M177.487 372.123C177.487 372.123 216.635 318.856 325.839 297.309",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgAfricanEmptyState);
export default ForwardRef;
